import { CartSummaryCard } from '@eliadmin/core/src/components/cart/cart-summary-card';
import { CartOrderForm } from '@eliadmin/core/src/components/cart/order/cart-order-form';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { Container } from '@eliadmin/core/src/components/ui/container';
import { GenericLoader } from '@eliadmin/core/src/components/ui/generic-loader';
import { CartStep, useCartStepper } from '@eliadmin/core/src/hooks/cart/use-cart-stepper';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Suspense } from 'react';

export function CartOrder() {
  const { t } = useTranslations();
  const { setStep } = useCartStepper();

  return (
    <>
      <Container className="py-8">
        <div className="flex flex-col  gap-4">
          <div className="mb-2 flex items-center justify-between">
            <span className="text-xl font-bold">{t('text360')}</span>
            <Button onClick={() => setStep(CartStep.DETAIL)} variant="secondary">
              {t('text522')}
            </Button>
          </div>

          <div className="flex flex-col gap-6 md:flex-row">
            {/* form */}
            <div className="flex-grow">
              <Suspense fallback={<GenericLoader />}>
                <CartOrderForm />
              </Suspense>
            </div>

            {/* summary */}
            <div className="relative h-full">
              <CartSummaryCard
                itemsDisplayType="total"
                className="sticky top-2 md:w-[400px]"
                showSubmitButton
              />
            </div>
          </div>

          {/* <div className="flex flex-col justify-start gap-4 md:flex-row md:justify-between">
            <Button onClick={handleContinue} disabled={!activePaymentId || !activeShipmentId}>
              {t('text526')}
            </Button>
          </div> */}
        </div>
      </Container>
    </>
  );
}
